import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	axisHelpText: {
		id: 'polaris-ideas.view-controls.config-matrix-axis.x-axis.axis-help-text',
		defaultMessage: 'Select a field for the x-axis in the view.',
		description: '',
	},
});
